<template>
    <div>
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="font-weight-normal mb-0 text-muted">Commission</p>
                    <h2 class="listing-title d-inline-block mb-0">Recruitment</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <RecruitmentListTable />
        </b-container>
    </div>
</template>
<script>
import RecruitmentListTable from '@/views/Commission/Recruitment/RecruitmentListTable'
export default {
    components: {
        RecruitmentListTable,
    },
}
</script>